module.exports = __webpack_public_path__ + "static/media/border-left.5bf45cae.svg";